import { useEffect,useState } from 'react';
import {
    Card, Table, TableBody, TableCell, Container, TableContainer, TablePagination,TableRow, Button
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import Page from './../../components/Page';
import Scrollbar from './../../components/Scrollbar';
import { UserListHead } from '../../sections/@dashboard/user';
import HeaderBreadcrumbs from './../../components/HeaderBreadcrumbs';
import { toast } from 'react-toastify';
import Loader from 'src/components/Loader';
import moment from 'moment'


import { getAllContactUsLsts } from 'src/redux/actions/ContactUsListAction';
import "./../BannerManagement/BannerManagement.css"
import { values } from 'lodash';

export default function ContactUsList() {
    const [rowsPerPage, setRowsPerPage] = useState(25);
    // const UserList = useSelector((state) => state.users.user_list.data);
    const [selected, setSelected] = useState([]);

    const [page, setPage] = useState(0);
    
    
    const dispatch = useDispatch();
    const contact_us_api_data = useSelector(state => state.states.state_list.data);    
    console.log(contact_us_api_data)
    const USERLIST = contact_us_api_data !== undefined && contact_us_api_data.data;
    console.log(">>>>>>?????",contact_us_api_data)
    
    // const contact_us_list = useSelector(data)
    const loadingSelector = useSelector(state => state.states.loading)
    const updateSelector = useSelector(state => state.states.state_updated)
    
    useEffect(() => {
        dispatch(getAllContactUsLsts())
    }, [dispatch])

    useEffect(() => {
        if (Object.keys(updateSelector).length > 0) {
            if (updateSelector.status) {
                toast.success(updateSelector.data.message, { theme: "colored" })
            }
        }
    }, [updateSelector])

    // const handleStateStatus = (value) => {
    //     console.log("value.status", value.status)
    //     let data = {
    //         ...value,
    //         status: value.status === 1 ? 2 : 1
    //     }
    //     dispatch(UpdateStateStatusAction(data))
    // }

    const [state, setState] = useState({
        userList: [],
    });

    useEffect(() => {
        if (contact_us_api_data !== undefined) {
            setState({ ...state, userList: contact_us_api_data.data.data});
        }
    }, [contact_us_api_data]);

    useEffect(() => {
        dispatch(getAllContactUsLsts((page + 1), rowsPerPage));
    }, [dispatch, page, rowsPerPage]);



    const handleChangePage = (_, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value));
        setPage(0);
    };

    return (
        <Page title="Cricket Teams Manager">
            {loadingSelector ? <Loader /> : null}

            <Container maxWidth="lg">
                <HeaderBreadcrumbs
                    heading="All Contact Us List"
                    links={[
                        { name: 'Dashboard', href: "/dashboard/app" },
                        { name: 'All Contact Us List' }
                    ]}
                />

                <Card>
                    <Scrollbar>
                        <TableContainer sx={{ minWidth: 800 }}>
                            <Table>
                                <UserListHead
                                    headLabel={[
                                        // { id: "c_no", label: "Sr no.", alignRight: false },
                                        { id: 'name', label: 'Name', alignRight: false },
                                        { id: 'status', label: 'Email', alignRight: false },
                                        { id: 'phone', label: 'Mobile Number', alignRight: false },
                                        { id: 'subject', label: 'Subject', alignRight: false },
                                        { id: 'message', label: 'Message', alignRight: false },
                                        { id: 'date', label: 'Created At', alignRight: false }
                                    ]}
                                    rowCount={contact_us_api_data ?.data.total_count}
                                    numSelected={selected.length}
                                />

                                <TableBody>
                                    {contact_us_api_data && contact_us_api_data.data && contact_us_api_data.data.data.map((value, index) => { 
                                            return (
                                                <TableRow key={index}>
                                                    <TableCell>{value.name}</TableCell>
                                                    <TableCell>{value.email}</TableCell>
                                                     <TableCell>{value.phone}</TableCell> 
                                                    <TableCell>{value.subject}</TableCell> 
                                                    <TableCell>{value.message}</TableCell> 
                                                    <TableCell>{moment(value.createdAt).format("DD-MM-YYYY HH:mm:ss")}</TableCell> 
                                                </TableRow>
                                            ); 
                                      }) 
                                     } 
                                    
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Scrollbar>
                    <TablePagination
                        rowsPerPageOptions={[1,25, 50, 100, 150, 200]}
                        component="div"
                        count={contact_us_api_data ?.data.total_count}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Card>
            </Container>
        </Page>
    );
}
